<template>
  <div id="nsrcard">
    <v-toolbar flat color="white">
      <v-toolbar-title>Bank Statement Monthly Averages</v-toolbar-title>
    </v-toolbar>

    <!-- AVERAGES TABLE -->
    <AveragesTable :caculateTotalAverage="caculateTotalAverageForAgg" />
    <!-- AVERAGES TABLE END -->

    <!-- BANK ACCOUNT AND STATEMENTS -->
    <div style="padding-top:10px;">
      <v-expansion-panel v-model="panel" expand class>
        <v-expansion-panel-content
          class="bankheadercolor"
          v-for="(accountItem, index) in bankAccounts"
          :key="index"
        >
          <div slot="header" class="pl-3">
            <b>{{accountItem.bank_account_name}}</b>
          </div>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="fcsRow[index].data"
              hide-actions
              v-bind:pagination.sync="pagination"
              :key="fcsRow.id"
              class="elevation-1"
              no-data-text="No bank statement has been added."
            >
              <template slot="items" slot-scope="props">
                <tr v-if="props.item.calculate_row == 0" style="background-color:#ECEFF1">
                  <td style="padding-left:5px;" class="text-xs-right">
                    <!-- <a :href=" props.item.file_link" target="_blank">{{ props.item.month_name }}</a> -->
                    <span>{{props.item.month_name}}</span>
                    <span v-if="props.item.month_year != '0'">{{ props.item.month_year }}</span>
                  </td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >Unscrubbed</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >-</td>
                </tr>
                <tr v-else>
                  <td style="padding-left:5px;" class="text-xs-right">
                    <!-- <a :href=" props.item.file_link" target="_blank">{{ props.item.month_name }}</a> -->
                    <span>{{formatDate(props.item.month_name)}}</span>
                  </td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_deposit_amount) }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_transfer_amount) }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link )"
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_other_advances) }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_deduction) }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_net_deposits) }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >{{ props.item.month_number_of_deposits }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >{{ props.item.month_negative_days }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_average_balance) }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_monthly_beginning_balance) }}</td>
                  <td
                    @click="editItem(props.item, index, accountItem.bank_account_name, props.item.file_link)"
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_monthly_ending_balance)}}</td>
                </tr>
              </template>
              <template slot="footer">
                <tr style="height: 25px;">
                  <td class="font-weight-bold text-xs-right pb-3">Averages:</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{ formatPrice( caculateAverage(index, 'month_deposit_amount') ) }}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{ formatPrice( caculateAverage(index, 'month_transfer_amount') ) }}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{ formatPrice( caculateAverage(index, 'month_other_advances') ) }}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{ formatPrice( caculateAverage(index, 'month_deduction') ) }}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{ formatPrice( caculateAverage(index, 'month_net_deposits') ) }}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >{{caculateAverage(index, 'month_number_of_deposits')}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >{{caculateAverage(index, 'month_negative_days')}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{ formatPrice( caculateAverage(index, 'month_average_balance') ) }}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{ formatPrice( caculateAverage(index, 'month_monthly_beginning_balance') ) }}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{ formatPrice( caculateAverage(index, 'month_monthly_ending_balance') ) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <!-- ACCOUNT AGGREGATION SECTION -->

    <div style="padding-top:10px;">
          <v-card>
            <v-toolbar flat color="white" class="py-2">
               <b>Account Aggregation</b>
               <v-spacer></v-spacer>
                <ShowChart :uniqProducts="fcsCompanyRow.reverse()"/>
              <!-- <account-aggregation-chart :uniqProducts="fcsCompanyRow"></account-aggregation-chart> -->
            </v-toolbar>

            <v-data-table
              :headers="aggHeaders"
              :items="fcsCompanyRow"
              hide-actions
              :key="fcsCompanyRow.id"
              :rows-per-page-items="[{'text':'All','value':-1},5,10,25]"
              class="elevation-1"
              no-data-text="No bank statement has been added."
              style="padding-right: 10px;"
            >
              <template slot="items" slot-scope="props">
                <tr v-if="props.item.calculate_row == 0" style="background-color:#ECEFF1">
                  <td style="padding-left:5px;" class="text-xs-right">
                    {{ props.item.month_name }}
                  </td>
                  <td class="text-xs-right">Unscrubbed</td>
                  <td class="text-xs-right">-</td>
                  <td class="text-xs-right">-</td>
                  <td class="text-xs-right">-</td>
                  <td class="text-xs-right">-</td>
                  <td class="text-xs-right">-</td>
                  <td class="text-xs-right">-</td>
                  <td class="text-xs-right">-</td>
                  <td class="text-xs-right">-</td>
                  <td class="text-xs-right">-</td>
                  <td></td>
                </tr>
                <tr v-else>
                  <td style="padding-left:5px;" class="text-xs-right">
                    {{ formatDate(props.item.month_name) }}
                  </td>
                  <td class="text-xs-right">${{ formatPrice(props.item.month_deposit_amount) }}</td>
                  <td class="text-xs-right">${{ formatPrice(props.item.month_transfer_amount) }}</td>
                  <td class="text-xs-right">${{ formatPrice(props.item.month_other_advances) }}</td>
                  <td class="text-xs-right">${{ formatPrice(props.item.month_deduction) }}</td>
                  <td class="text-xs-right">${{ formatPrice(props.item.month_net_deposits) }}</td>
                  <td class="text-xs-right">{{ props.item.month_number_of_deposits }}</td>
                  <td class="text-xs-right">{{ props.item.month_negative_days }}</td>
                  <td class="text-xs-right">${{ formatPrice(props.item.month_average_balance) }}</td>
                  <td
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_monthly_beginning_balance) }}</td>
                  <td
                    class="text-xs-right"
                  >${{ formatPrice(props.item.month_monthly_ending_balance)}}</td>
                  <td></td>
                </tr>
              </template>
              <template slot="footer">
                <tr style="height: 25px;">
                  <td class="font-weight-bold text-xs-right pb-3">Averages:</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{formatPrice(caculateTotalAverageForAgg.deposit_amount)}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{formatPrice(caculateTotalAverageForAgg.trans_amount)}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{formatPrice(caculateTotalAverageForAgg.other_advance)}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{formatPrice(caculateTotalAverageForAgg.month_deduction)}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{formatPrice(caculateTotalAverageForAgg.net_deposit)}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >{{caculateTotalAverageForAgg.number_deposit}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >{{caculateTotalAverageForAgg.negative_days}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{formatPrice(caculateTotalAverageForAgg.daily_balance)}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{formatPrice(caculateTotalAverageForAgg.month_monthly_beginning_balance)}}</td>
                  <td
                    class="font-weight-bold text-xs-right pb-3"
                  >${{formatPrice(caculateTotalAverageForAgg.month_monthly_ending_balance)}}</td>
                  <td></td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
      
    </div>

    <!-- EDIT BANK NAME DIALOG -->
  </div>
  <!-- EDIT BANK NAME DIALOG END -->
</template>
<script>
import AveragesTable from "./AveragesTable";
import fcs_helper from "../../helpers/fcs_helper";
import ShowChart from './ShowChart'
import moment from 'moment'

export default {
  mixins: [fcs_helper],
  components: {
    AveragesTable,
    ShowChart
  },
  data() {
    return {
      aggHeaders: [
        {
          text: "Month",
          align: "right",
          sortable: false,
          value: "name",
          width: "1%"
        },
        {
          text: "Total Deposits",
          value: "month_name",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Transfer Amt",
          value: "fat",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Other Advances",
          value: "carbs",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Misc Deductions",
          value: "miscDeductions",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Net Deposits",
          value: "protein",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "# of Deposits",
          value: "lender",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "NSF",
          value: "date",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Average Bal",
          value: "averageBalance",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Beginning Bal",
          value: "beginningBalance",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Ending Bal",
          value: "endingBalance",
          align: "right",
          sortable: false,
          width: "1%"
        },
        { text: "", value: "", align: "right", sortable: false, width: "1%" }
      ],
      pagination: { sortBy: "column1", descending: true, rowsPerPage: -1 },
      headers: [
        {
          text: "Month",
          align: "right",
          sortable: false,
          value: "name",
          width: "1%"
        },
        {
          text: "Total Deposits",
          value: "month_name",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Transfer Amt",
          value: "fat",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Other Advances",
          value: "carbs",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Misc Deductions",
          value: "miscDeductions",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Net Deposits",
          value: "protein",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "# of Deposits",
          value: "lender",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "NSF",
          value: "date",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Average Bal",
          value: "averageBalance",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Beginning Bal",
          value: "beginningBalance",
          align: "right",
          sortable: false,
          width: "1%"
        },
        {
          text: "Ending Bal",
          value: "endingBalance",
          align: "right",
          sortable: false,
          width: "1%"
        }
      ],
      panel: [true]
    };
  },
  async mounted() {
    for (var i = 0; i < this.bankAccounts && this.bankAccounts.length; i++) {
      this.panel.push(false);
    }
  },
  methods: {
    formatDate(date){
      return moment(date, 'YYYY-MM-DD').format('YYYY-MM')
    },
    caculateAverage(index, key_name) {
      let x = this.fcsRow[index];
      let removed_unscrubbed = _.filter(x.data, o => o.calculate_row != 0);
      let sum =
        removed_unscrubbed.length == 0
          ? 0
          : _.sumBy(x.data, function(res) {
              return res.calculate_row != 0 && res[key_name] != null
                ? parseFloat(res[key_name])
                : 0;
            }) / removed_unscrubbed.length;
      return sum.toFixed(2);
    }
  }
};
</script>
<style scoped>
.bankheadercolor {
  background: linear-gradient(to left, #99ccff 0%, #ffffff 100%);
}
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  white-space: normal;
  height: 25px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  line-height: 1;
  font-size: 14px;
}
.effect-1 ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3399ff;
  transition: 0.4s;
}
.effect-1:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}

.customClass {
  margin: 1px;
}
</style>
<style>
#nsrcard .v-expansion-panel__header {
  min-height: 0px !important;
  height: 30px !important;
}
.v-toolbar__content {
  padding-left: 0px !important;
}
</style>